import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { freeFetch } from './api';
import { useFreeAuth } from './FreeAuth';

export default function FreeVerify() {
  const navigate = useNavigate();
  const { markSignedIn } = useFreeAuth();
  const [error, setError] = useState('');

  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get('token');
    if (!token) {
      setError('This link is invalid or has expired.');
      return;
    }
    freeFetch('/auth/verify', { method: 'POST', body: JSON.stringify({ token }) })
      .then((data) => {
        markSignedIn(data.email);
        navigate('/free/dashboard', { replace: true });
      })
      .catch(() => setError('This link is invalid or has expired.'));
  }, [navigate, markSignedIn]);

  return (
    <div className="min-h-screen flex items-center justify-center px-6" data-testid="free-verify-page">
      {!error ? (
        <p className="text-mono-mute font-body" data-testid="free-verify-loading">Verifying your access link...</p>
      ) : (
        <div className="text-center max-w-md">
          <p className="text-white font-body text-lg mb-6" data-testid="free-verify-error">{error}</p>
          <Link
            to="/free"
            className="inline-block bg-white hover:bg-[#E5E5E5] text-black font-heading font-bold uppercase tracking-wider rounded-none px-8 py-3 transition-colors"
            data-testid="free-verify-back-btn"
          >
            Request a new link
          </Link>
        </div>
      )}
    </div>
  );
}
